<template>
  <div id="contenedor-evento-card">
    <v-card
      class="rounded-xl"
      width="100%"
      min-height="150px">
      <v-card-title class="pb-1 px-1 pt-0">
        <div class="d-inline-block text-truncate col-10">
          {{ evento.nombre }}
        </div>
        <v-spacer></v-spacer>
        <v-menu rounded offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              color="grey lighten-1">
              <v-icon>
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>
          <v-list nav dense>
            <v-list-item @click="$emit('editarEvento', evento)">
              <v-list-item-icon>
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Editar
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isEventOverdue" @click="$emit('eliminarEvento', evento)">
              <v-list-item-icon>
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Borrar
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-card-subtitle class="pt-0 px-3">
        <v-chip small :color="getColorDayDifference(evento)">
          <v-icon left small>
            mdi-calendar-clock
          </v-icon>
          <FechaHumano :fecha="new Date(`${evento.fecha} ${evento.hora}`)">
          </FechaHumano>
        </v-chip>
      </v-card-subtitle>
      <v-card-text style="min-height: 80px;">
        <b>Asunto:</b>
        <CortarTextos :texto="evento.asunto" :cantidad-caracteres="80"></CortarTextos>
      </v-card-text>
      <v-card-actions>
        <v-btn small text rounded color="primary" class="text-capitalize"
        @click="mostrarDetalles = true">
          Detalles
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="mostrarDetalles"
      scrollable
      width="450px">
      <v-card dense>
        <v-card-title class="mb-1">
          Detalles: {{ evento.nombre }}
          <v-spacer></v-spacer>
          <v-btn icon @click="mostrarDetalles = false">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pl-5 pb-2">
        <v-chip small :color="getColorDayDifference(evento)">
          <v-icon left small>
            mdi-calendar-clock
          </v-icon>
          <FechaHumano :fecha="new Date(`${evento.fecha} ${evento.hora}`)">
          </FechaHumano>
        </v-chip>
      </v-card-subtitle>
        <v-divider class="mx-2"></v-divider>
        <v-card-text class="pa-2">
          <div class="grey lighten-5 pa-2 rounded-lg">
            <span class="font-weight-bold">
              <v-icon left color="blue">
                mdi-calendar-text
              </v-icon>
              Asunto:
            </span>
            {{ evento.asunto }}
          </div>
          <div class="mt-2 pa-2">
            <v-icon left color="red">
              mdi-map-marker
            </v-icon>
            <span class="font-weight-bold">Lugar:</span>
            {{ evento.lugar }}
          </div>
        </v-card-text>
        <v-divider class="mx-2"></v-divider>
        <v-card-actions class="py-4"></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CortarTextos from '@/components/CortarTextos.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'AgendaEvetoCard',
  components: {
    CortarTextos,
    FechaHumano,
  },
  props: {
    evento: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarDetalles: false,
    };
  },
  methods: {
    getColorDayDifference(evento) {
      const fechaEvento = new Date(`${evento.fecha} ${evento.hora}`);
      const fechaActual = new Date();
      const diferencia = Math.floor((fechaEvento - fechaActual) / (1000 * 60 * 60 * 24));
      if (diferencia < 0) return 'grey lighten-4';
      if (diferencia >= 0 && diferencia <= 3) return 'warning';
      if (diferencia < 7) return 'yellow';
      return 'success';
    },
  },
  computed: {
    isEventOverdue() {
      const fechaEvento = new Date(`${this.evento.fecha} ${this.evento.hora}`);
      const fechaActual = new Date();
      return fechaEvento < fechaActual;
    },
  },
};
</script>

<style lang="scss">

</style>
